var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2437_9861)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.49983 0C2.46267 0 0 2.4625 0 5.49983C0 8.53716 2.46267 10.9997 5.49983 10.9997C8.5377 10.9997 11 8.53718 11 5.49983C11 2.46247 8.5377 0 5.49983 0ZM6.46555 8.02484C6.24308 8.27174 6.11557 8.41848 5.87544 8.64804C5.51197 8.99559 5.09925 9.08813 4.77838 8.74506C4.31718 8.2518 4.8009 6.75123 4.81269 6.6944C4.89932 6.29557 5.07222 5.49843 5.07222 5.49843C5.07222 5.49843 4.69868 5.72711 4.47691 5.80822C4.31335 5.86798 4.12833 5.7895 4.08259 5.63131C4.03996 5.48475 4.07391 5.39153 4.16367 5.29139C4.38612 5.04466 4.51363 4.89792 4.75378 4.66836C5.1176 4.32064 5.52997 4.2283 5.85084 4.57117C6.31204 5.06443 5.97175 5.87596 5.85222 6.45098C5.84044 6.50798 5.55698 7.81797 5.55698 7.81797C5.55698 7.81797 5.93053 7.58927 6.15229 7.50802C6.31617 7.44842 6.50121 7.52707 6.54695 7.68509C6.5896 7.83168 6.55531 7.92488 6.46555 8.02484ZM5.86887 3.78372C5.35569 3.82875 4.90349 3.44934 4.85843 2.9358C4.81375 2.42279 5.19316 1.97042 5.70636 1.92573C6.21919 1.88068 6.67174 2.26046 6.71644 2.77346C6.76148 3.28649 6.3817 3.73903 5.86887 3.78372Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2437_9861"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/INFO.2880905f87680cee694b439ed7c225c8.svg";
export { ForwardRef as ReactComponent };